import { render, staticRenderFns } from "./ResendVerificationCodeForm.vue?vue&type=template&id=0ac3b97a&scoped=true&"
import script from "./ResendVerificationCodeForm.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationCodeForm.vue?vue&type=script&lang=js&"
import style0 from "./ResendVerificationCodeForm.vue?vue&type=style&index=0&id=0ac3b97a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3b97a",
  null
  
)

export default component.exports